import React, { useEffect, useState } from "react"
import * as api from '../../../../../Auth/auth'

import MICROCARD from "./MicroCard"
//import MICROCHART from "./MICROCHART"


function GETMICRO() {

       const [data1, setData1] = useState([])
      // const [data2, setData2] = useState([])
      

      useEffect(() => {

        async function axios_get() {
            const response = await api.micro()
            const microValue = response
            setData1(microValue);
            
            getLatestDataset(data1)

            }
    
        axios_get()
         
        }, []);
        

// "data1" is an array with one or more datasets - depending on number of microbiome samples of the user --> get the latest if there are more than 1
let latest= []
function getLatestDataset(data1) {
    
    if (data1.length) {
        latest = (data1.reduce((m,v,i) => (v.id > m.id) && i ? v : m).id)-1 
        
        setData1(data1[latest])
        
   }
 }



let micro = data1.map(i => i.Species)



    return (
    
             <>
                    <MICROCARD data={micro}  /> 
                    
             </>          
            
    )
}

export default GETMICRO;

